<script>
import ChargemapB2BButton from "../../b2b/global/ChargemapB2BButton.vue";
export default {
  name: "DrawerCloseButton",
  components: {
    ChargemapB2BButton
  },
  props: {
    showCloseButton: {
      type: Boolean,
      required: true
    }
  },
  emits: ["closeDrawer"],
  methods: {
    closeDrawer() {
      this.$emit("closeDrawer");
    }
  }
};
</script>

<template>
    <div
        class="md:pointer-events-auto transition-all duration-300 ease-in-out z-50"
        :class="
  showCloseButton ? 'opacity-100 h-8 w-8 pointer-events-auto select-auto' : 'opacity-0 h-0 w-0 overflow-hidden pointer-events-none select-none'
"
    >
        <ChargemapB2BButton
            variant="secondary"
            class="w-full h-full"
            v-bind="$attrs"
            @click="closeDrawer"
        >
            <template #icon>
                <IconX class="size-6 text-slate-500" />
            </template>
        </ChargemapB2BButton>
    </div>
</template>
